import { combineReducers } from 'redux'

import sonidos from 'app/store/reducers/sounds/sonidos.reducer'
import sounds from 'app/store/reducers/sounds/sounds.reducer'
import { soundKeys, SOUNDS_TYPE } from 'app/constants/sounds.constants'

const SoundsReducer = combineReducers({
  [soundKeys[SOUNDS_TYPE.SONIDOS]]: sonidos,
  [soundKeys[SOUNDS_TYPE.SOUNDS]]: sounds,
})

export default SoundsReducer
